{
    "version": "1.2.0",
    "catalogKeys": [
        "perm.users.create_collaborator",
        "perm.users.create_expert_employee",
        "perm.users.view_users",
        "perm.users.create_company_user",
        "perm.users.edit_user",
        "perm.users.delete_user",
        "perm.users.manage_access",
        "perm.companies.view",
        "perm.companies.create",
        "perm.companies.edit",
        "perm.companies.delete",
        "perm.companies.import",
        "perm.companies.manage_clients",
        "perm.reports.fill",
        "perm.reports.read_schema",
        "perm.reports.generate",
        "perm.reports.review",
        "perm.reports.workfile",
        "perm.reports.export",
        "perm.reports.supervise",
        "perm.reports.lock",
        "perm.reports.unlock",
        "perm.reports.restore",
        "perm.missions.start",
        "perm.missions.close",
        "perm.missions.archive",
        "perm.files.delete",
        "perm.connections.manage_api",
        "perm.cabinet.manage_control_level",
        "perm.ownership.transfer",
        "perm.billing.manage",
        "perm.cabinet.edit"
    ],
    "groups": [
        {
            "groupKey": "cabinet",
            "entries": [
                {
                    "uiKey": "ownership_transfer",
                    "type": "boolean",
                    "keys": [
                        "perm.ownership.transfer"
                    ]
                },
                {
                    "uiKey": "cabinet_edit",
                    "type": "boolean",
                    "keys": [
                        "perm.cabinet.edit"
                    ]
                },
                {
                    "uiKey": "cabinet_manage_control_level",
                    "type": "boolean",
                    "keys": [
                        "perm.cabinet.manage_control_level"
                    ]
                },
                {
                    "uiKey": "connections_manage_api",
                    "type": "boolean",
                    "keys": [
                        "perm.connections.manage_api"
                    ]
                },
                {
                    "uiKey": "billing_manage",
                    "type": "boolean",
                    "keys": [
                        "perm.billing.manage"
                    ]
                }
            ]
        },
        {
            "groupKey": "users",
            "entries": [
                {
                    "uiKey": "users_manage_access",
                    "type": "boolean",
                    "keys": [
                        "perm.users.manage_access"
                    ]
                },
                {
                    "uiKey": "users_manage",
                    "type": "boolean",
                    "keys": [
                        "perm.users.create_collaborator",
                        "perm.users.create_expert_employee",
                        "perm.users.create_company_user",
                        "perm.users.edit_user",
                        "perm.users.delete_user"
                    ]
                },
                {
                    "uiKey": "companies_manage",
                    "type": "boolean",
                    "keys": [
                        "perm.companies.create",
                        "perm.companies.edit",
                        "perm.companies.delete",
                        "perm.companies.import"
                    ]
                },
                {
                    "uiKey": "companies_manage_clients",
                    "type": "boolean",
                    "keys": [
                        "perm.companies.manage_clients"
                    ]
                }
            ]
        },
        {
            "groupKey": "vsme",
            "entries": [
                {
                    "uiKey": "missions_start",
                    "type": "boolean",
                    "keys": [
                        "perm.missions.start"
                    ]
                },
                {
                    "uiKey": "missions_close",
                    "type": "boolean",
                    "keys": [
                        "perm.missions.close"
                    ]
                },
                {
                    "uiKey": "missions_archive",
                    "type": "boolean",
                    "keys": [
                        "perm.missions.archive"
                    ]
                },
                {
                    "uiKey": "reports_fill",
                    "type": "boolean",
                    "keys": [
                        "perm.reports.fill"
                    ]
                },
                {
                    "uiKey": "reports_workfile",
                    "type": "boolean",
                    "keys": [
                        "perm.reports.workfile"
                    ]
                },
                {
                    "uiKey": "reports_control",
                    "type": "review_level",
                    "keys": [
                        "perm.reports.review",
                        "perm.reports.supervise"
                    ]
                },
                {
                    "uiKey": "reports_generate",
                    "type": "boolean",
                    "keys": [
                        "perm.reports.generate"
                    ]
                },
                {
                    "uiKey": "reports_export",
                    "type": "boolean",
                    "keys": [
                        "perm.reports.export"
                    ]
                },
                {
                    "uiKey": "files_delete",
                    "type": "boolean",
                    "keys": [
                        "perm.files.delete"
                    ]
                }
            ]
        }
    ],
    "hiddenKeys": [
        {
            "key": "perm.users.view_users",
            "reason": "baseline_only"
        },
        {
            "key": "perm.companies.view",
            "reason": "baseline_only"
        },
        {
            "key": "perm.reports.read_schema",
            "reason": "baseline_only"
        },
        {
            "key": "perm.reports.lock",
            "reason": "baseline_only"
        },
        {
            "key": "perm.reports.unlock",
            "reason": "baseline_only"
        },
        {
            "key": "perm.reports.restore",
            "reason": "baseline_only"
        }
    ],
    "roleEditorScopes": {
        "mission_responsable": {
            "groupKeys": [
                "vsme"
            ],
            "entryUiKeys": [
                "missions_close",
                "reports_generate",
                "reports_workfile",
                "reports_export"
            ]
        }
    }
}
